import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { TabList as ReactTabList } from "react-tabs";
import { styled, themeGet } from "@catchoftheday/theme";
import { listStyleProps } from "../List";
export var TabList = styled(ReactTabList)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  border-bottom: 2px solid ", ";\n  padding: 0;\n\n  ", ";\n"])), themeGet("colors.grey"), listStyleProps);
TabList.tabsRole = "TabList";
export default TabList;